import { Component, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { BaseComponent } from '../../../components/base/base.component';
import IJob from '../../../_interfaces/IJob';
import { JobsService } from '../../../_services/jobs/jobs.service';
import { SessionService } from '../../../_services/session/session.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AdminTableActionsComponent } from '../../admin-ui/admin-table-actions/admin-table-actions.component';
import { AdminListToolbarComponent } from '../../admin-ui/admin-list-toolbar/admin-list-toolbar.component';
import { AdminStatePanelComponent } from '../../admin-ui/admin-state-panel/admin-state-panel.component';
@Component({
  standalone: true,
  selector: 'app-table-jobs',
  templateUrl: './table-jobs.component.html',
  styleUrls: ['./table-jobs.component.scss'],
  imports: [
    CommonModule,
    TableModule,
    TranslatePipe,
    ButtonModule,
    AdminTableActionsComponent,
    AdminListToolbarComponent,
    AdminStatePanelComponent,
  ],
})
export class TableJobsComponent extends BaseComponent implements OnInit {
  public jobs: IJob[] = [];
  public filteredJobs: IJob[] = [];
  public searchValue = '';

  constructor(
    public confirmationService: ConfirmationService,
    public jobsService: JobsService,
    public messageService: MessageService,
    public errorsService: ErrorsService,
    public translate: TranslateService,
    public session: SessionService,
    public router: Router,
  ) {
    super(session);
    this.jobs = [];
  }

  load() {
    this.jobs = [];
    this.jobsService.getJobs(this.customers_id).subscribe({
      next: (jobs: IJob[]) => {
        this.jobs = jobs;
        this.onSearch(this.searchValue);
      },
      error: (error) => {
        const code = this.errorsService.getMessageFromJobError(error);
        this.messageService.add({
          summary: this.translate.instant('MESSAGES.JOBS.ERROR.SUMMARY'),
          detail: this.translate.instant(`MESSAGES.JOBS.ERROR.${code}`),
          severity: 'error',
        });
      },
    });
  }

  onSearch(value: string): void {
    this.searchValue = value;
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredJobs = [...this.jobs];
      return;
    }
    this.filteredJobs = this.jobs.filter((job) =>
      (job.name || '').toLowerCase().includes(query),
    );
  }

  deleteJob(job: IJob) {
    this.jobsService.delete(this.customers_id, job).subscribe({
      next: () => {
        this.load();
        this.messageService.add({
          summary: this.translate.instant('MESSAGES.JOBS.DELETE.SUMMARY'),
          detail: this.translate.instant('MESSAGES.JOBS.DELETE.DETAIL', {
            job: job.name,
          }),
          severity: 'success',
        });
      },
      error: (error) => {
        const code =
          this.errorsService.getMessageFromMarketingChannelError(error);
        this.messageService.add({
          summary: this.translate.instant('MESSAGES.JOBS.ERROR.SUMMARY'),
          detail: this.translate.instant(`MESSAGES.JOBS.ERROR.${code}`),
          severity: 'error',
        });
      },
    });
  }

  confirm(job: IJob) {
    this.confirmationService.confirm({
      message: this.translate.instant('ADMIN.JOBS.CONFIRM.DELETE.TEXT', {
        job: job.name,
      }),
      header: this.translate.instant('ADMIN.JOBS.CONFIRM.DELETE.TITLE', {
        job: job.name,
      }),
      accept: this.deleteJob.bind(this, job),
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.load();
  }
}
